export var ChannelStatus;
(function (ChannelStatus) {
    ChannelStatus["CONNECTING"] = "CONNECTING";
    ChannelStatus["CONNECTED"] = "CONNECTED";
    ChannelStatus["RECONNECTING"] = "RECONNECTING";
    ChannelStatus["FAILED"] = "FAILED";
    ChannelStatus["INIT_FAILED"] = "INIT_FAILED";
})(ChannelStatus || (ChannelStatus = {}));
//# sourceMappingURL=channel-types.js.map